/**
 * Attempts to fetch a Creator key from Cloudflare storage.
 */
export async function validateKey(key?: string, sessionId?: string) {
    if (!key && !sessionId) throw new Error("No key nor sessionId")
    const payload = key ? { key } : { sessionId }
    const response = await fetch("/validate-key", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    })
    return response.json()  // creatorKey || null
}

/**
 * Attempts to create a checkout session at Stripe.
 */
export async function createCheckoutSession(pathname: string, lang: string) {
    const response = await fetch("/stripe/create-checkout-session", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ from: pathname, lang: lang })
    })
    return response.json()  // session
}

/**
 * 🐶
 */
export async function getImageAsset(message: string) {
    const response = await fetch("/easter-egg", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ message: message })
    })
    return response.text()  // asset
}